import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useSnrAuthorizationsSuspenseQuery } from '../../../graphql/react-operations';
import { Alert } from '@startuptools/ui/Alert';
import { Box } from '@startuptools/ui/Box';
import { Card } from '@startuptools/ui/Card';
import { DateFormat } from '@startuptools/ui/DateFormat';
import { Table } from '@startuptools/ui/Table';
import { Trans, useLingui } from '@lingui/react';
import { Fragment } from 'react';
import { SnrFilingLink } from './SnrFilingLink';

export const SnrAuthorizations = () => {
  const companyId = useCompanyId();
  const { i18n } = useLingui();
  const { data } = useSnrAuthorizationsSuspenseQuery({ variables: { companyId } });

  if (data.snrAuthorizations.length === 0) {
    return (
      <Alert variant="outlined">
        <Trans id="We could not find any registered Authorizations" />
      </Alert>
    );
  }

  return (
    <Card>
      <Table sx={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th>
              <Trans id="Registration Date" />
            </th>
            <th>
              <Trans id="Regarding" />
            </th>
            <th align="right">
              <Trans id="Filing Number" />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.snrAuthorizations.map(b => {
            return (
              <tr key={b.id}>
                <td>{b.registrationDate && <DateFormat locale={i18n.locale}>{b.registrationDate}</DateFormat>}</td>
                <td>
                  {b.auths.map((a, i) => (
                    <Fragment key={a.kind}>
                      <Box component="span" sx={{ textTransform: 'capitalize' }}>
                        {a.kind}
                      </Box>
                      {i < b.auths.length - 1 && ', '}
                    </Fragment>
                  ))}
                </td>
                <td align="right">
                  <SnrFilingLink filingYear={b.filingYear} filingNumber={b.filingNumber} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Card>
  );
};
